<template>
    <div class="eol-header-box">
        <div :class="['eol-logo-box', school_code == HZSFYQWY_CODE ? 'large-logo' : '']" v-if="school_code">
            <!-- 100051院校不显示分割线和平台名称，使用特殊类名控制LOGO尺寸 -->
            <img class="school-logo" :src="schoolInfo && schoolInfo.school_logo" />
            <template v-if="school_code != HZSFYQWY_CODE && school_code != utils.qhk12_code">
                <span class="split-line"></span>
                <div class="eol-system-name">信息服务中心</div>
            </template>
        </div>
        <ul class="eol-menu-box" v-if="school_code != utils.qhk12_code">
            <!--  school_code == YXLX_CODE 100041下线研学旅行 20251031 -->
            <li v-if="school_code == sxyxlxCode" :class="$route.path.indexOf('sxyxlx') > -1 ? 'menu-items active' : 'menu-items'">
                <router-link class="jeol-shixun-href" :to="`/${school_code}/custom/sxyxlx`">研学旅行</router-link>
            </li>
            <!-- <li v-if="school_code == specialCode" :class="$route.path.indexOf('yxlx') > -1 ? 'menu-items active' : 'menu-items'">
        <router-link class="jeol-shixun-href" :to="`/${school_code}/yxlx`">研学旅行</router-link>
      </li> -->
            <li v-if="loginUserInfo && loginUserInfo.show_menu && loginUserInfo.show_menu.indexOf('school') > -1" class="menu-items" @click="goToSchool()">
                <a href="javascript:void(0)">学校主页</a>
            </li>
            <li v-if="services.DEPLOY !== 'hzvtc'" class="menu-items">
                <a class="jeol-shixun-href" @click="goAppsCenter('worker')" href="javascript:void(0)">工作台</a>
            </li>
            <li
                v-if="loginUserInfo && loginUserInfo.show_menu && loginUserInfo.show_menu.indexOf('xuexi') > -1"
                @click="goToClass()"
                :class="$route.path.indexOf('/user') > -1 ? 'menu-items active' : 'menu-items'"
            >
                <!-- <a class="jeol-shixun-href" href="#" target="_blank">学习中心</a> -->
                <a class="jeol-shixun-href" href="javascript:void(0)">学习中心</a>
            </li>
            <li v-if="loginUserInfo && loginUserInfo.user_type == 2" class="menu-items">
                <a class="jeol-shixun-href" @click="goAppsCenter('userManage')" href="javascript:void(0)">用户管理</a>
            </li>
        </ul>
        <div :class="['eol-right-user', menuOpen ? 'up' : 'down']" @mouseleave="menuOpen = false" @click="menuOpen = !menuOpen">
            <div class="login-btn" v-if="!loginUserInfo || loginUserInfo.school_code != school_code" @click="handleLogin()">登录</div>
            <template v-else>
                <div class="mine-lines">
                    <div class="user-imgs-box"></div>
                    <span>{{ loginUserInfo && loginUserInfo.name ? loginUserInfo.name : loginUserInfo && loginUserInfo.username }}</span>
                </div>
                <ul @mouseleave="menuOpen = false" class="eol-submine-box">
                    <template v-if="services.DEPLOY !== 'hzvtc'">
                        <li class="submine-items">
                            <a :href="`${services.LOGIN_SERVER}/${school_code}/worker`">信息服务中心</a>
                        </li>
                        <li class="submine-items">
                            <a :href="`${services.LOGIN_SERVER}/${school_code}/userInfo`">个人信息</a>
                        </li>
                        <li class="submine-items">
                            <a :href="`${services.LOGIN_SERVER}/${school_code}/editPassword`">修改密码</a>
                        </li>
                    </template>
                    <li class="submine-items" @click="logoutEvents">
                        <a href="javascript:;">退出登录</a>
                    </li>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import services from '../config/services';
    import utils from '../config/utils';
    export default {
        name: 'Header',
        components: {},
        data() {
            return {
                services,
                menuOpen: false,
                school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem('schoolCode'),
                specialCode: services.StudyCode,
                sxyxlxCode: services.SXYXLX_CODE,
                YXLX_CODE: services.YXLX_CODE,
                HZSFYQWY_CODE: 100051,
                utils,
            };
        },
        computed: {
            ...mapState({
                loginUserInfo: (state) => state.appsLogin.appsUserInfo,
                schoolInfo: (state) => state.appsLogin.schoolInfo,
            }),
        },
        async created() {
            console.log(this.school_code != utils.qhk12_code);

            await this.getAppsLoginUserInfo().then((res) => {
                if (res.code == '0000') {
                    // this.getLoginSchoolInfo({ school_code: res.data.school_code });
                    this.school_code = res.data.school_code;
                }
            });
            await this.getLoginSchoolInfo({ school_code: this.school_code }).then((res) => {
                if (res.code == '0000') utils.setTitle(document.title + '-' + res.data.school_name);
            });
            await this.judgeSchool();
        },
        methods: {
            ...mapActions(['requestAppsLogout', 'getAppsLoginUserInfo', 'getLoginSchoolInfo']),
            // 跳转到信息服务中心
            goAppsCenter(type) {
                window.open(`${services.LOGIN_SERVER}/${this.school_code}/${type}`, '_self');
            },
            // 退出登录
            logoutEvents() {
                let that = this;
                this.requestAppsLogout().then((res) => {
                    if (res.code == '0000') {
                        if (res.data && res.data.redirect) {
                            window.open(res.data.redirect, 'self');
                        } else {
                            window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${that.school_code}&from=${window.location.href}`, '_self');
                        }
                    }
                });
            },
            goToClass() {
                utils.redirect(this, `/${this.school_code}/user/center`);
            },
            // 去学校主页
            goToSchool() {
                if (this.school_code) {
                    // window.open(`${services.JIAOYU_SCHOOL}/school/${this.school_code}`, '_blank')
                }
            },

            judgeSchool() {
                if (process.env.NODE_ENV == 'development') {
                    this.specialCode = '100064';
                } else {
                    if (process.env.VUE_APP_FLAG === 'pro') {
                        // 正式环境
                        this.specialCode = '100035';
                    } else {
                        // 测试环境
                        this.specialCode = '100064';
                    }
                }
            },
            handleLogin() {
                window.open(`${services.APPS_SERVIER}/api/redirect?school_code=${this.school_code}&from=${window.location.href}`, '_self');
            },
        },
    };
</script>

<style lang="less" scoped>
    /* header --- start */
    .eol-header-box {
        min-width: 1200px;
        width: 100%;
        height: 70px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 23, 73, 0.06);
        display: flex;
        align-items: center;
        justify-content: space-between;
        z-index: 10;
    }

    .eol-header-box .eol-logo-box {
        height: 34px;
        overflow: hidden;
        display: flex;
        align-items: center;
        margin-left: 20px;
        &.large-logo {
            overflow: unset;
            .school-logo {
                max-width: none;
                max-height: none;
                height: 36px;
            }
        }
    }

    .eol-header-box .eol-logo-box .split-line {
        width: 1px;
        height: 17px;
        background: #c0c1cc;
        margin: 0 15px;
        display: inline-block;
    }

    .eol-header-box .eol-logo-box .school-logo {
        width: auto;
        height: auto;
        max-height: 34px;
        max-width: 300px;
    }

    .eol-header-box .eol-logo-box .eol-system-name {
        font-size: 16px;
        font-weight: bold;
        color: #464748;
        display: inline-block;
        vertical-align: middle;
    }

    .eol-header-box .eol-menu-box {
        display: inline-block;
        vertical-align: top;
        text-align: center;
        flex: 1;
    }

    .eol-header-box .menu-items {
        display: inline-block;
        height: 70px;
        line-height: 70px;
        vertical-align: top;
        font-size: 16px;
        font-weight: bold;
        color: #63676e;
        text-align: center;
        width: 16%;
        position: relative;
    }

    .eol-header-box .menu-items a {
        font-size: 16px;
        font-weight: bold;
        color: #63676e;
        display: block;
        cursor: pointer;
        text-align: center;
    }

    .eol-header-box .menu-items a:hover {
        color: #125cfb;
        text-decoration: none;
    }

    .eol-header-box .menu-items.active a {
        color: #125cfb;
    }
    .eol-header-box .menu-items.active {
        background: #e9f0ff;
        box-shadow: 0px 0px 8px 0px rgba(0, 23, 73, 0.06);
    }
    .eol-header-box .menu-items.active::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: #125cfd;
    }
    .login-btn {
        font-size: 14px;
        color: #666666;
        cursor: pointer;
    }
    .eol-header-box .eol-right-user {
        display: inline-block;
        vertical-align: top;
        margin-right: 30px;
        max-width: 260px;
        position: relative;
    }

    .eol-header-box .eol-right-user .close-page-box {
        position: absolute;
        display: inline-block;
        font-size: 16px;
        color: #3a3a3a;
        display: inline-block;
        margin-left: 5px;
        top: 13px;
        left: -80px;
        cursor: pointer;
    }

    .eol-header-box .eol-right-user .close-page-box img {
        vertical-align: -4px;
    }

    .eol-header-box .eol-right-user .mine-lines {
        height: 70px;
        line-height: 70px;
        font-size: 14px;
        font-weight: 400;
        color: #125cfb;
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .eol-header-box .eol-right-user .mine-lines span {
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        max-width: 200px;
        margin: 0 16px 0 6px;
    }

    .eol-header-box .eol-right-user .mine-lines::after {
        content: '';
        display: inline-block;
        width: 12px;
        height: 12px;
        background-image: url('../assets/site/header/icons-jiantou-down.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        margin-left: 4px;
    }

    .eol-header-box .eol-right-user.up .mine-lines::after {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
        -webkit-transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
    }

    .eol-header-box .eol-right-user.down .mine-lines::after {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: -webkit-transform 0.3s;
        transition: transform 0.3s;
    }

    .eol-header-box .eol-right-user .user-imgs-box {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 4px;
        vertical-align: middle;
        text-align: right;
        background: url('../assets/site/header/mine-icons.png') no-repeat center;
        background-size: 100% auto;
    }

    .eol-header-box .eol-right-user .eol-submine-box {
        background: #ffffff;
        border: 1px solid #dfe3e4;
        position: absolute;
        z-index: 1000;
        top: 70px;
        right: -10px;
        padding: 18px 15px 18px 20px;
        text-align: left;
        display: none;
        min-width: 130px;
    }

    .eol-header-box .eol-right-user.up .eol-submine-box {
        display: block;
    }

    .eol-header-box .eol-right-user.down .eol-submine-box {
        display: none;
    }

    .eol-header-box .eol-right-user .submine-items {
        height: 30px;
        color: #71737b;
        line-height: 30px;
        font-size: 14px;
        cursor: pointer;
    }
    .eol-header-box .eol-right-user .submine-items a {
        display: block;
        width: auto;
        color: #71737b;
    }

    .eol-header-box .eol-right-user .submine-items.active,
    .eol-header-box .eol-right-user .submine-items:hover a {
        color: #3460e4;
        text-decoration: none;
    }

    .eol-header-box .eol-right-user .mine-left-icons {
        width: 14px;
        height: 14px;
        margin-right: 6px;
        display: inline-block;
        vertical-align: -2px;
    }
    /* header ---- 结束 */

    @media only screen and (max-height: 780px) {
    }
</style>
